import useQueryURL from "../../../../../common/hooks/useQueryURL";
import TuleButton from "../../../../../common/components/atom/TuleButton.tsx/TuleButton";

/**
 * Add organization button presenter
 * Open Add organization modal
 * @returns 
 */
export default function AddOrgnazationBtnPresenter({modalId}: {modalId?: string}) {
  const { setQueryValue } = useQueryURL();
  const MODAL_ID_PARAMS = modalId || "modal_add_org";
  const onClick = () => {
    setQueryValue({ [MODAL_ID_PARAMS]: "true" });
  };
  return (
    <TuleButton
      label="Ajouter une organisation"
      onClick={onClick}
      color={{
        text: "white",
        background: "#042536",
        border: "#3684A650",
      }}
    />
  );
}
